/*ěščřžýáíéúů*/
document.addEventListener("DOMContentLoaded", function () {
    // Section-based progress bar for submenu navigation
    function initScrollProgressBar() {
        const progressBar = document.querySelector(".progress-bar");
        const submenu = document.querySelector(".submenu-function");
        if (!progressBar || !submenu) return;

        // Get all navigation links and their corresponding sections
        const navLinks = submenu.querySelectorAll('.menu__nav-item[href^="#"]');
        const sections = Array.from(navLinks)
            .map((link) => {
                const sectionId = link.getAttribute("href").substring(1);
                return document.getElementById(sectionId);
            })
            .filter((section) => section !== null);

        if (sections.length === 0) return;

        // Add active class management
        function updateActiveNavItem(activeIndex) {
            navLinks.forEach((link, index) => {
                link.classList.toggle("active", index === activeIndex);
            });
        }

        function updateProgressBar() {
            // Only update if navbar is sticky
            if (!submenu.classList.contains("sticky")) {
                progressBar.style.width = "0%";
                navLinks.forEach((link) => link.classList.remove("active"));
                return;
            }

            let activeIndex = -1;
            const triggerOffset = 150; // Posun trigger pointu níž

            // Najdi aktivní sekci - jednoduchá logika
            for (let i = sections.length - 1; i >= 0; i--) {
                const section = sections[i];
                const rect = section.getBoundingClientRect();

                // Sekce je aktivní když trigger point prošel její horní hranici
                if (rect.top <= triggerOffset) {
                    activeIndex = i;
                    break;
                }
            }

            // Progress podle navigačních položek - rovnoměrné rozdělení
            let progressPercent = 0;
            if (activeIndex >= 0) {
                // Každá navigační položka má stejnou váhu
                const sectionWeight = 100 / sections.length;

                // Progress začíná na začátku sekce a postupně roste
                progressPercent = activeIndex * sectionWeight;

                // Přidej malý progress uvnitř sekce
                const activeSection = sections[activeIndex];
                const rect = activeSection.getBoundingClientRect();

                if (rect.top <= triggerOffset) {
                    const sectionHeight = activeSection.offsetHeight;
                    const scrolledInSection = Math.max(0, triggerOffset - rect.top);
                    const sectionProgress = Math.min(scrolledInSection / sectionHeight, 1);

                    // Progres v sekci je limitován na 90% váhy sekce (kromě poslední)
                    if (activeIndex < sections.length - 1) {
                        progressPercent += sectionProgress * sectionWeight * 0.9;
                    } else {
                        // Poslední sekce může jít až na 100%
                        progressPercent += sectionProgress * sectionWeight;
                    }
                }
            }

            // Zajisti že progress je v rozmezí 0-100
            progressPercent = Math.max(0, Math.min(100, progressPercent));

            progressBar.style.width = progressPercent + "%";
            updateActiveNavItem(activeIndex);

            // Debug info pro testování
            if (window.debugProgress) {
                console.log(`Active: ${activeIndex}, Progress: ${progressPercent.toFixed(1)}%, Sections: ${sections.length}`);
            }
        }

        window.addEventListener("scroll", updateProgressBar);
        updateProgressBar();

        // Update when clicking on nav items
        navLinks.forEach((link, index) => {
            link.addEventListener("click", (e) => {
                e.preventDefault(); // Prevent default anchor behavior

                // Get target section
                const targetId = link.getAttribute("href").substring(1);
                const targetSection = document.getElementById(targetId);

                if (targetSection) {
                    // Scroll to the target section with offset for sticky header
                    const headerHeight = document.querySelector("header, .site-header")?.offsetHeight || 0;
                    const adminBarHeight = document.querySelector("#wpadminbar")?.offsetHeight || 0;
                    const submenuHeight = submenu.offsetHeight || 0;
                    const totalOffset = headerHeight + adminBarHeight + submenuHeight + 20; // Extra 20px buffer


                    const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - totalOffset;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: "smooth",
                    });

                    // Immediately update active state and progress bar
                    updateActiveNavItem(index);

                    // Set progress bar to the exact position for this nav item
                    // Každá navigační položka má stejnou váhu
                    const sectionWeight = 100 / sections.length;
                    const navProgress = index * sectionWeight; // Na začátek sekce
                    progressBar.style.width = navProgress + "%";

                    // Update again after scroll completes
                    setTimeout(() => {
                        updateProgressBar();
                    }, 800); // Longer delay for smooth scroll
                }
            });
        });
    }

    initScrollProgressBar();

    // Function Software Show More functionality
    function initFunctionSoftwareShowMore() {
        const showMoreBtn = document.querySelector(".show-more-btn");
        if (!showMoreBtn) return;

        const hiddenBoxes = document.querySelectorAll(".hidden-box");
        let isExpanded = false;

        showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();

            if (!isExpanded) {
                // Show hidden boxes with smooth animation
                hiddenBoxes.forEach((box, index) => {
                    setTimeout(() => {
                        box.style.display = "";
                        box.style.opacity = "0";
                        box.style.transform = "translateY(20px)";

                        // Trigger animation
                        requestAnimationFrame(() => {
                            box.style.transition = "opacity 0.3s ease, transform 0.3s ease";
                            box.style.opacity = "1";
                            box.style.transform = "translateY(0)";
                        });
                    }, index * 50); // Stagger animation
                });

                // Hide the button with smooth animation after all boxes are shown
                setTimeout(
                    () => {
                        showMoreBtn.style.transition = "opacity 0.3s ease, transform 0.3s ease";
                        showMoreBtn.style.opacity = "0";
                        showMoreBtn.style.transform = "translateY(-10px)";

                        // Remove button from layout after animation
                        setTimeout(() => {
                            showMoreBtn.style.display = "none";
                        }, 300);
                    },
                    hiddenBoxes.length * 50 + 100,
                );

                isExpanded = true;
            }
        });
    }

    initFunctionSoftwareShowMore();

    // Sticky submenu funkcionalita
    function initStickySubmenu() {
        const header = document.querySelector("header, .site-header");
        const submenu = document.querySelector(".submenu-function");
        const adminBar = document.querySelector("#wpadminbar");

        if (!header || !submenu) return;

        // Vyčisti staré placeholder elementy při inicializaci
        document.querySelectorAll(".submenu-sticky-placeholder").forEach((el) => {
            el.remove();
        });

        let headerHeight = header.offsetHeight;
        let adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
        let submenuOffset = submenu.getBoundingClientRect().top + window.pageYOffset;
        let isSticky = false;

        function handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            // Trigger point: Když dosáhneme submenu sekci
            const triggerPoint = submenuOffset - headerHeight - adminBarHeight;

            if (scrollTop >= triggerPoint) {
                if (!isSticky) {
                    // Schoj hlavičku ihned
                    header.style.transform = `translateY(-100%)`;
                    header.style.transition = "transform 0.3s ease";

                    // Aktivuj sticky submenu ihned na místo hlavičky
                    submenu.classList.add("sticky");
                    submenu.style.position = "fixed";
                    submenu.style.top = adminBarHeight + "px";
                    submenu.style.left = "0";
                    submenu.style.right = "0";
                    submenu.style.width = "100%";
                    submenu.style.transform = "translateY(0)";
                    submenu.style.zIndex = "999";

                    isSticky = true;
                }
            } else {
                if (isSticky) {
                    // Zobraz hlavičku
                    header.style.transform = "translateY(0)";

                    // Deaktivuj sticky submenu
                    submenu.classList.remove("sticky");
                    submenu.style.position = "";
                    submenu.style.top = "";
                    submenu.style.left = "";
                    submenu.style.right = "";
                    submenu.style.width = "";
                    submenu.style.transform = "";
                    submenu.style.zIndex = "";

                    isSticky = false;
                }
            }
        }

        // Submenu zůstává vždy viditelné - odstraněny hover efekty

        // Throttle scroll event pro performance
        let ticking = false;
        window.addEventListener("scroll", () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    handleScroll();
                    ticking = false;
                });
                ticking = true;
            }
        });

        // Recalculate na resize
        window.addEventListener("resize", () => {
            headerHeight = header.offsetHeight;
            adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
            submenuOffset = submenu.getBoundingClientRect().top + window.pageYOffset;

            // Pokud je sticky, aktualizuj pozici
            if (isSticky) {
                submenu.style.top = adminBarHeight + "px";
            }
        });
    }

    // Inicializuj sticky submenu
    initStickySubmenu();

    // SwiperJS pro testimonials
    function initTestimonialSwiper() {
        const testimonialSwiper = new Swiper(".testimonial__content", {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".buttons__next",
                prevEl: ".buttons__prev",
            },
            on: {
                slideChange() {
                    // Reset všechny progress bary
                    const allProgressBars = document.querySelectorAll(".testimonial__progress .progress-fill");
                    allProgressBars.forEach((bar) => {
                        bar.style.width = "0%";
                    });

                    // Spusť animaci pro aktivní slide
                    setTimeout(() => {
                        const activeSlide = document.querySelector(".swiper-slide-active");
                        if (activeSlide) {
                            const progressBar = activeSlide.querySelector(".testimonial__progress .progress-fill");
                            if (progressBar) {
                                progressBar.style.width = "100%";
                            }
                        }
                    }, 100);
                },
                init() {
                    // Spusť animaci pro první slide
                    setTimeout(() => {
                        const activeSlide = document.querySelector(".swiper-slide-active");
                        if (activeSlide) {
                            const progressBar = activeSlide.querySelector(".testimonial__progress .progress-fill");
                            if (progressBar) {
                                progressBar.style.width = "100%";
                            }
                        }
                    }, 100);
                },
            },
        });
    }

    // Inicializuj testimonial swiper
    if (document.querySelector(".testimonial__content")) {
        initTestimonialSwiper();
    }

    // SwiperJS pro posts slider
    function initPostsSwiper() {
        const postsSwiper = new Swiper(".posts__slider-swiper", {
            slidesPerView: "auto",
            spaceBetween: 16,
            loop: false,
            freeMode: true,
            navigation: {
                nextEl: ".buttons-posts__next",
                prevEl: ".buttons-posts__prev",
            },
        });
    }

    // Inicializuj posts swiper
    if (document.querySelector(".posts__slider-swiper")) {
        initPostsSwiper();
    }

    // SwiperJS pro posts slider
    function initInstalationSwiper() {
        const postsSwiper = new Swiper(".instalation__slider-swiper", {
            slidesPerView: "auto",
            spaceBetween: 16,
            loop: false,
            freeMode: true,
            navigation: {
                nextEl: ".buttons-instalation__next",
                prevEl: ".buttons-instalation__prev",
            },
        });
    }

    // Inicializuj instalation swiper
    if (document.querySelector(".instalation__slider-swiper")) {
        initInstalationSwiper();
    }

    // YouTube video modal funkcionalita
    function initVideoModal() {
        const videoCards = document.querySelectorAll(".card__image--video");

        videoCards.forEach((card) => {
            card.addEventListener("click", function () {
                const embedUrl = this.getAttribute("data-embed-url");
                if (embedUrl) {
                    openVideoModal(embedUrl);
                }
            });
        });
    }

    function openVideoModal(embedUrl) {
        // Vytvoř modal
        const modal = document.createElement("div");
        modal.className = "video-modal";
        modal.innerHTML = `
            <div class="video-modal__backdrop">
                <div class="video-modal__content">
                    <button class="video-modal__close">×</button>
                    <div class="video-modal__iframe-container">
                        <iframe
                            src="${embedUrl}?autoplay=1&rel=0"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen>
                        </iframe>
                    </div>
                </div>
            </div>
        `;

        // Přidej do stránky
        document.body.appendChild(modal);
        document.body.style.overflow = "hidden";

        // Event listeners pro zavření
        const closeBtn = modal.querySelector(".video-modal__close");
        const backdrop = modal.querySelector(".video-modal__backdrop");

        closeBtn.addEventListener("click", closeVideoModal);
        backdrop.addEventListener("click", function (e) {
            if (e.target === backdrop) {
                closeVideoModal();
            }
        });

        // Zavři na ESC
        document.addEventListener("keydown", handleEscKey);

        function closeVideoModal() {
            document.body.removeChild(modal);
            document.body.style.overflow = "";
            document.removeEventListener("keydown", handleEscKey);
        }

        function handleEscKey(e) {
            if (e.key === "Escape") {
                closeVideoModal();
            }
        }
    }

    // Inicializuj video modal funkcionalitu
    if (document.querySelector(".card__image--video")) {
        initVideoModal();
    }

    // FAQs akordeon funkcionalita
    function initFAQs() {
        const faqItems = document.querySelectorAll(".faqs .items__item");

        faqItems.forEach((item) => {
            const header = item.querySelector(".faq-header");
            const description = item.querySelector(".faq-description");
            const icon = item.querySelector("svg");

            if (header && description) {
                // Skryj description na začátku
                description.style.display = "none";

                // Přidej click event
                header.addEventListener("click", function () {
                    const isOpen = description.style.display !== "none";

                    // Zavři všechny ostatní FAQs
                    faqItems.forEach((otherItem) => {
                        const otherDescription = otherItem.querySelector(".faq-description");
                        const otherIcon = otherItem.querySelector("svg");

                        if (otherItem !== item && otherDescription) {
                            $(otherDescription).slideUp(300);
                            if (otherIcon) {
                                otherIcon.style.transform = "rotate(0deg)";
                            }
                        }
                    });

                    // Toggle aktuální FAQ
                    if (isOpen) {
                        $(description).slideUp(300);
                        if (icon) {
                            icon.style.transform = "rotate(0deg)";
                        }
                    } else {
                        $(description).slideDown(300);
                        if (icon) {
                            icon.style.transform = "rotate(180deg)";
                        }
                    }
                });

                // Nastav cursor pointer pro header
                header.style.cursor = "pointer";

                // Přidej transition pro ikonu
                if (icon) {
                    icon.style.transition = "transform 0.3s ease";
                }
            }
        });
    }

    // Inicializuj FAQs
    if (document.querySelector(".faqs")) {
        initFAQs();
    }

    $(document).on("click", ".text-item", function (e) {
        var t = e.target;
        var el = t && t.nodeType === 1 ? t : t && t.parentElement;
        var isLink = el && (el.tagName === "A" || (el.closest && el.closest("a")));
        if (isLink) return;
        e.preventDefault();
        var $checkbox = $(this).closest(".item").find('input[type="checkbox"]');
        if ($checkbox.length) {
            $checkbox.iCheck("toggle");
        }
    });

    $(document).on("click", ".icheckbox", function (e) {
        var $input = $(this).find('input[type="checkbox"]');
        if ($input.length) {
            $input.iCheck("toggle");
        }
    });
});

function updateRangeProgress(input) {
    const min = parseFloat(input.min) || 0;
    const max = parseFloat(input.max) || 100;
    const value = parseFloat(input.value);
    const percentage = ((value - min) / (max - min)) * 100;

    input.style.background = `linear-gradient(to right, 
                var(--blue-600-primary, #0B465D) 0%, 
                var(--blue-600-primary, #0B465D) ${percentage}%, 
               var(--Grey-200, #E4EBF0) ${percentage}%, 
                var(--Grey-200, #E4EBF0) 100%)`;
}

/* // Ceník konfigurátor
class PricingCalculator {
    constructor() {
        this.monthlyFee = 16000; // Měsíční poplatek

        this.deviceCount = 1;
        this.unitCount = 500;
        this.selectedModules = [];

        // Cenová tabulka podle počtu bytů
        this.priceTable = {
            20: { first: 4000, additional: 500, modules: { ucetnictvi: 1500, pohoda: 500, abra: 1500, insolvence: 500, druzstva: 5000 } },
            50: { first: 7000, additional: 1000, modules: { ucetnictvi: 2500, pohoda: 1000, abra: 2500, insolvence: 1000, druzstva: 5000 } },
            100: { first: 10000, additional: 1500, modules: { ucetnictvi: 3500, pohoda: 1500, abra: 3500, insolvence: 1500, druzstva: 5000 } },
            200: { first: 15000, additional: 2000, modules: { ucetnictvi: 5000, pohoda: 2000, abra: 5000, insolvence: 2000, druzstva: 5000 } },
            300: { first: 20000, additional: 3000, modules: { ucetnictvi: 7000, pohoda: 3000, abra: 7000, insolvence: 3000, druzstva: 7000 } },
            500: { first: 25000, additional: 4000, modules: { ucetnictvi: 8000, pohoda: 4000, abra: 8000, insolvence: 4000, druzstva: 8000 } },
            1000: { first: 35000, additional: 5000, modules: { ucetnictvi: 10000, pohoda: 5000, abra: 10000, insolvence: 5000, druzstva: 10000 } },
            1500: { first: 40000, additional: 6000, modules: { ucetnictvi: 12000, pohoda: 6000, abra: 12000, insolvence: 6000, druzstva: 12000 } },
            2000: { first: 45000, additional: 8000, modules: { ucetnictvi: 16000, pohoda: 8000, abra: 16000, insolvence: 8000, druzstva: 16000 } },
            3000: { first: 55000, additional: 12000, modules: { ucetnictvi: 18000, pohoda: 12000, abra: 18000, insolvence: 12000, druzstva: 18000 } },
            4000: { first: 65000, additional: 16000, modules: { ucetnictvi: 24000, pohoda: 16000, abra: 24000, insolvence: 16000, druzstva: 24000 } },
            5000: { first: 75000, additional: 20000, modules: { ucetnictvi: 30000, pohoda: 20000, abra: 30000, insolvence: 20000, druzstva: 30000 } },
            6000: { first: 85000, additional: 24000, modules: { ucetnictvi: 34000, pohoda: 24000, abra: 34000, insolvence: 24000, druzstva: 34000 } },
            7000: { first: 95000, additional: 28000, modules: { ucetnictvi: 38000, pohoda: 28000, abra: 38000, insolvence: 28000, druzstva: 38000 } },
            8000: { first: 105000, additional: 32000, modules: { ucetnictvi: 42000, pohoda: 32000, abra: 42000, insolvence: 32000, druzstva: 42000 } },
            9000: { first: 115000, additional: 36000, modules: { ucetnictvi: 46000, pohoda: 36000, abra: 46000, insolvence: 36000, druzstva: 46000 } },
            10000: { first: 125000, additional: 40000, modules: { ucetnictvi: 50000, pohoda: 40000, abra: 50000, insolvence: 40000, druzstva: 50000 } },
        };

        this.init();
    }

    init() {
        // Počkej chvíli než inicializuješ iCheck, ať se DOM úplně načte
        setTimeout(() => {
            // Inicializuj iCheck plugin pokud je dostupný
            if (typeof $ !== "undefined" && $.fn.iCheck) {
                $(".col-left__standard-modul .icheck").iCheck({
                    checkboxClass: "icheckbox",
                    radioClass: "iradio",
                });
            }

            this.bindEvents();

            // Nastav počáteční hodnotu do input pole
            this.initializeUnitInput();

            // Proveď kompletní aktualizaci všech cen
            this.updateCalculation();
        }, 150);
    }

    initializeUnitInput() {
        const unitInput = document.getElementById("range-value");
        if (unitInput) {
            const formattedValue = this.unitCount.toLocaleString("cs-CZ");
            unitInput.value = formattedValue;
        }
    }

    // Definuj kroky podle ceníku
    getSteps() {
        return [20, 50, 100, 200, 300, 500, 1000, 1500, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000];
    }

    getNextStep(currentValue) {
        const steps = this.getSteps();

        // Najdi nejbližší vyšší krok
        for (let step of steps) {
            if (step > currentValue) {
                return step;
            }
        }

        // Pokud jsme na posledním kroku nebo vyšší, zůstaň na maximu
        return Math.max(currentValue, steps[steps.length - 1]);
    }

    getPreviousStep(currentValue) {
        const steps = this.getSteps();

        // Najdi nejbližší nižší krok
        for (let i = steps.length - 1; i >= 0; i--) {
            if (steps[i] < currentValue) {
                return steps[i];
            }
        }

        // Pokud jsme na prvním kroku nebo nižší, zůstaň na minimu
        return Math.min(currentValue, steps[0]);
    }

    bindEvents() {
        // Range slider pro počet jednotek
        const rangeInput = document.getElementById("number");
        if (rangeInput) {
            rangeInput.addEventListener("input", (e) => {
                this.unitCount = parseInt(e.target.value);
                this.updateUnitDisplay();
                this.updateCalculation();
                updateRangeProgress(rangeInput);
            });

            // Nastavit počáteční hodnotu range
            updateRangeProgress(rangeInput);
        }

        // Input pole pro manuální zadání počtu jednotek
        const unitInput = document.getElementById("range-value");
        if (unitInput) {
            unitInput.addEventListener("input", (e) => {
                let value = parseInt(e.target.value) || 20;
                value = Math.max(20, Math.min(10000, value));
                this.unitCount = value;
                if (rangeInput) rangeInput.value = this.unitCount;
                this.updateCalculation();
                updateRangeProgress(rangeInput);
            });

            unitInput.addEventListener("blur", (e) => {
                // Zajisti, že hodnota je v povoleném rozsahu po opuštění pole
                let value = parseInt(e.target.value) || 20;
                value = Math.max(20, Math.min(10000, value));
                e.target.value = value.toLocaleString("cs-CZ");
                this.unitCount = value;
                if (rangeInput) rangeInput.value = this.unitCount;
                this.updateCalculation();
                updateRangeProgress(rangeInput);
            });

            unitInput.addEventListener("focus", (e) => {
                // Při focusu ukaž čisté číslo bez formátování
                e.target.value = this.unitCount;
            });
        }

        // Tlačítka pro range slider - progresivní krokování
        const rangeMinusBtn = document.querySelector(".range-minus");
        const rangePlusBtn = document.querySelector(".range-plus");

        if (rangeMinusBtn) {
            rangeMinusBtn.addEventListener("click", () => {
                const newValue = this.getPreviousStep(this.unitCount);
                if (newValue !== this.unitCount) {
                    this.unitCount = newValue;
                    if (rangeInput) rangeInput.value = this.unitCount;
                    this.updateUnitDisplay();
                    this.updateCalculation();
                    updateRangeProgress(rangeInput);
                }
            });
        }

        if (rangePlusBtn) {
            rangePlusBtn.addEventListener("click", () => {
                const newValue = this.getNextStep(this.unitCount);
                if (newValue !== this.unitCount) {
                    this.unitCount = newValue;
                    if (rangeInput) rangeInput.value = this.unitCount;
                    this.updateUnitDisplay();
                    this.updateCalculation();
                    updateRangeProgress(rangeInput);
                }
            });
        }

        // Počítač zařízení - ODSTRANĚNO (používá se nový systém v CenikCalculator)
        // Starý event handler byl odstraněn kvůli konfliktu s novým systémem

        // Checkboxy pro moduly - použij nový systém kalkulace
        const moduleCheckboxes = document.querySelectorAll(".col-left__standard-modul .module-checkbox");
        moduleCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
                // Použij nový PriceCalculator místo starého systému
                if (window.priceCalculator && typeof window.priceCalculator.calculate === 'function') {
                    window.priceCalculator.calculate();
                } else {
                    this.updateSelectedModules();
                    this.updateCalculation();
                }
            });
        });

        // iCheck události - použij nový systém kalkulace
        if (typeof $ !== "undefined" && $.fn.iCheck) {
            $(".col-left__standard-modul .module-checkbox").on("ifChanged", () => {
                // Použij nový PriceCalculator místo starého systému
                if (window.priceCalculator && typeof window.priceCalculator.calculate === 'function') {
                    window.priceCalculator.calculate();
                } else {
                    this.updateSelectedModules();
                    this.updateCalculation();
                }
            });
        }
    }

    updateUnitDisplay() {
        const valueDisplay = document.getElementById("range-value");
        if (valueDisplay) {
            // Pouze aktualizuj pokud pole není aktivní (focused)
            if (document.activeElement !== valueDisplay) {
                const formattedValue = this.unitCount.toLocaleString("cs-CZ");
                valueDisplay.value = formattedValue;
            }
        }

        // Aktualizuj také v souhrnu - počet jednotek
        const totalUnits = document.querySelector(".total__item.number-units p:last-child");
        if (totalUnits) {
            totalUnits.textContent = this.unitCount.toLocaleString("cs-CZ");
        }
    }

    updateDeviceDisplay() {
        const deviceDisplay = document.querySelector(".button-count p");
        if (deviceDisplay) {
            deviceDisplay.textContent = this.deviceCount;
        }
    }

    updateSelectedModules() {
        this.selectedModules = [];
        const checkboxes = document.querySelectorAll(".col-left__standard-modul .icheck");
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                this.selectedModules.push({
                    name: checkbox.name,
                    price: this.modulePrice,
                });
            }
        });
    }

    // Najdi nejbližší cenu podle počtu bytů
    getCurrentPricing() {
        const steps = this.getSteps();

        // Najdi nejbližší nižší nebo stejný krok
        let selectedStep = steps[0];
        for (let step of steps) {
            if (step <= this.unitCount) {
                selectedStep = step;
            } else {
                break;
            }
        }

        return this.priceTable[selectedStep];
    }

    calculateTotalPrice() {
        const pricing = this.getCurrentPricing();

        // Základní cena za zařízení
        let deviceTotal = pricing.first;
        if (this.deviceCount > 1) {
            deviceTotal += (this.deviceCount - 1) * pricing.additional;
        }

        // Cena za moduly podle typu
        let modulesTotal = 0;
        this.selectedModules.forEach((module) => {
            const moduleName = this.getModuleKey(module.name);
            if (pricing.modules[moduleName]) {
                modulesTotal += pricing.modules[moduleName];
            }
        });

        // Celková jednorázová cena
        return deviceTotal + modulesTotal;
    }

    // Mapuj názvy modulů na klíče v tabulce
    getModuleKey(moduleName) {
        const mapping = {
            "Účetnictví pro SVJ": "ucetnictvi",
            POHODA: "pohoda",
            ABRA: "abra",
            Insolvence: "insolvence",
            "Bytová družstva": "druzstva",
        };
        return mapping[moduleName] || "ucetnictvi";
    }

    updateCalculation() {
        const totalPrice = this.calculateTotalPrice();

        // Aktualizuj hlavní cenu s animací
        const mainPrice = document.querySelector(".price .h2");
        if (mainPrice) {
            this.animatePrice(mainPrice, totalPrice.toLocaleString("cs-CZ") + " Kč");
        }

        // Aktualizuj souhrn - "Jednorázově" (one-time)
        const summaryPrice = document.querySelector(".total__item.one-time p:last-child");
        if (summaryPrice) {
            this.animatePrice(summaryPrice, totalPrice.toLocaleString("cs-CZ") + " Kč");
        }

        // Aktualizuj měsíční poplatek (zůstává konstantní)
        const monthlyPrice = document.querySelector(".total__item.month p:last-child");
        if (monthlyPrice) {
            monthlyPrice.textContent = this.monthlyFee.toLocaleString("cs-CZ") + " Kč";
        }

        // Aktualizuj počet jednotek v souhrnu
        this.updateUnitDisplay();

        // Aktualizuj detailní rozpis
        this.updateDetailedBreakdown();
    }

    animatePrice(element, newPrice) {
        if (!element) return;

        element.style.transition = "opacity 0.2s ease";
        element.style.opacity = "0.7";

        setTimeout(() => {
            element.textContent = newPrice;
            element.style.opacity = "1";
        }, 100);
    }

    updateDetailedBreakdown() {
        const pricing = this.getCurrentPricing();
        console.log("Current pricing for", this.unitCount, "units:", pricing);

        // Aktualizuj cenu za první zařízení - použij konkrétnější selektor
        const deviceSection = document.querySelector(".col-left__count");
        const deviceItems = deviceSection ? deviceSection.querySelectorAll(".item") : [];

        console.log("Found device items:", deviceItems.length);

        if (deviceItems.length >= 2) {
            // První položka - první zařízení
            const firstDevicePrice = deviceItems[0].querySelector("p:last-child");
            if (firstDevicePrice) {
                const newPrice = pricing.first.toLocaleString("cs-CZ") + " Kč";
                console.log("Setting first device price to:", newPrice);
                firstDevicePrice.textContent = newPrice;
            }

            // Druhá položka - další zařízení
            const additionalDevicePrice = deviceItems[1].querySelector("p:last-child");
            if (additionalDevicePrice) {
                const additionalCost = this.deviceCount * pricing.additional;
                const newPrice = additionalCost.toLocaleString("cs-CZ") + " Kč";
                console.log("Setting additional device price to:", newPrice);
                additionalDevicePrice.textContent = newPrice;
            }
        }

        // Aktualizuj ceny modulů
        this.updateModulePrices(pricing);

        // Zvýrazni vybrané moduly
        this.highlightSelectedModules();
    }

    updateModulePrices(pricing) {
        // Aktualizuj ceny jednotlivých modulů podle aktuálního počtu bytů
        const moduleItems = document.querySelectorAll(".col-left__standard-modul .item");
        moduleItems.forEach((item, index) => {
            const priceElement = item.querySelector("p:last-child");
            const checkbox = item.querySelector(".icheck");

            if (priceElement && checkbox) {
                const moduleName = this.getModuleKey(checkbox.name);
                const modulePrice = pricing.modules[moduleName] || 0;
                priceElement.textContent = modulePrice.toLocaleString("cs-CZ") + " Kč";
            }
        });
    }

    highlightSelectedModules() {
        const moduleItems = document.querySelectorAll(".col-left__standard-modul .item");
        moduleItems.forEach((item) => {
            const checkbox = item.querySelector(".icheck");
            if (checkbox && checkbox.checked) {
                item.style.backgroundColor = "rgba(11, 70, 93, 0.05)";
                item.style.borderRadius = "8px";
                item.style.transition = "background-color 0.3s ease";
            } else {
                item.style.backgroundColor = "";
            }
        });
    }
} */

// assets/js/cenik-calculator.js
(function ($) {
    "use strict";

    const CenikCalculator = {
        $root: null,
        cenikVariants: [],
        currentVariantIndex: 0,
        priceTable: [],
        tableHeaders: [],
        cenikType: "",
        allowedUnits: [],
        currentIndex: 0,
        currentUnits: 0,
        currentDevices: 1,
        columnsOverride: null, // volitelný override z data-columns

        /* ===== Utils ===== */
        cleanNum(val) {
            if (!val) return 0;
            if (typeof val === "number") return val;

            // Check if it's a text value like "V ceně"
            const str = String(val).toLowerCase().trim();
            if (str.includes("v cen") || str.includes("included") || str.includes("zahrnuto")) {
                return "included";
            }

            // Individuální cena (tabulka / ACF text: individuálně, individualně, …)
            if (/individu[áa]ln[ěe]|individual/i.test(str)) {
                return "individual";
            }

            const s = String(val)
                .replace(/\u00A0/g, " ")
                .replace(/Kč|,-|–|—/gi, "")
                .replace(/\s/g, "")
                .replace(",", ".");
            const m = s.match(/(\d+(?:\.\d+)?)/);
            return m ? parseFloat(m[1]) : 0;
        },

        isFinitePrice(v) {
            return typeof v === "number" && Number.isFinite(v);
        },

        formatPrice(val) {
            if (val === "included") {
                return "V ceně";
            }
            if (val === "individual") {
                return "Individuálně";
            }
            const n = Number(val);
            return Number.isFinite(n) ? n.toLocaleString("cs-CZ") + " Kč" : "0 Kč";
        },
        findPercent(text) {
            if (!text) return null;
            const m = String(text).match(/(\d+(?:[.,]\d+)?)\s*%/);
            return m ? parseFloat(m[1].replace(",", ".")) : null;
        },
        updateSliderFill() {
            const $r = this.$root.find(".variant-content-right:visible .range-slider-input");
            if (!$r.length) return;
            const val = parseInt($r.val(), 10) || 0;
            const min = parseInt($r.attr("min"), 10) || 0;
            const max = parseInt($r.attr("max"), 10) || 1;
            const pct = ((val - min) * 100) / Math.max(1, max - min);
            $r.css("background", `linear-gradient(to right, #0A6778 0%, #0A6778 ${pct}%, #E6EDF2 ${pct}%, #E6EDF2 100%)`);
        },

        /* ===== Detekce sloupců ===== */
        detectColumns() {
            // 1) pevný override (volitelně z data-columns)
            if (this.columnsOverride && Object.keys(this.columnsOverride).length) {
                return this.columnsOverride;
            }

            // 2) univerzální detekce podle pozice a obsahu hlaviček
            const map = {};

            // Základní struktura (první 3 sloupce jsou téměř vždy stejné)
            map.units = 0; // První sloupec = jednotky

            // Pro druhý a třetí sloupec zkontroluj obsah (přesnější pořadí)
            for (let i = 1; i < Math.min(3, this.tableHeaders.length); i++) {
                const header = this.tableHeaders[i].toLowerCase().trim();

                // Nejprve testuj specifičtější výrazy
                if (/(další|dalsi|additional|next)/i.test(header) && !map.next) {
                    map.next = i;
                } else if (/(první|prvni)/i.test(header) && !map.first) {
                    map.first = i;
                } else if (/(zařízení|zarizeni|konfigurac)/i.test(header) && !map.first) {
                    map.first = i;
                }
            }

            // Pevné pozice jako fallback
            if (map.first === undefined) map.first = 1;
            if (map.next === undefined) map.next = 2;

            // Detekce modulových sloupců (od 3. pozice dál)
            for (let i = 3; i < this.tableHeaders.length; i++) {
                const header = this.tableHeaders[i].toLowerCase().trim();

                if (/(účetnictví|ucetnictvi|pohoda|abra|insolvence)/i.test(header)) {
                    map.module_account = i;
                } else if (/(družstva|druzstva|složenky|slozenky|sms|pokročilé|pokrocile)/i.test(header)) {
                    map.module_druz = i;
                } else if (/(sledování|sledovani|změn|zmen|watch)/i.test(header)) {
                    map.module_watch = i;
                } else if (/(konfigurace|configuration|možnosti|moznosti|cloud)/i.test(header)) {
                    map.module_config = i;
                } else if (/(zvýšení|zvyseni|výkon|vykon|cpu|procesor)/i.test(header)) {
                    map.module_performance = i;
                }
            }

            // Detekce měsíčního sloupce (hledej od konce)
            for (let i = this.tableHeaders.length - 1; i >= 3; i--) {
                const header = this.tableHeaders[i].toLowerCase().trim();

                // Hledej sloupce s názvy obsahujícími datum nebo "cena"
                if (/(cena|platba|měsíční|mesicni|měsíčně|mesicne|Měsíčně|\d{1,2}\.\d{1,2}\.\d{4}|monthly)/i.test(header) && this.hasNumericValues(i)) {
                    map.monthly = i;
                    break;
                }
            }

            // Fallback - pokud nenajdeš, použij poslední sloupec s číselnými hodnotami
            if (map.monthly === undefined) {
                for (let i = this.tableHeaders.length - 1; i >= 0; i--) {
                    if (this.hasNumericValues(i)) {
                        map.monthly = i;
                        break;
                    }
                }
                if (map.monthly === undefined) map.monthly = this.tableHeaders.length - 1;
            }

            // Debug výstup pro kontrolu mapování
            console.log("Detekované sloupce:", {
                headers: this.tableHeaders,
                mapping: map,
            });

            return map;
        },

        // Pomocná funkce pro detekci sloupců s numerickými hodnotami
        hasNumericValues(columnIndex) {
            if (!this.priceTable || this.priceTable.length === 0) return false;

            for (let row of this.priceTable.slice(0, 3)) {
                // Zkontroluj první 3 řádky
                if (row[columnIndex]) {
                    const val = this.cleanNum(row[columnIndex]);
                    if (Number.isFinite(val) && val > 0) return true;
                }
            }
            return false;
        },

        detectCenikType() {
            const currentVariant = this.cenikVariants[this.currentVariantIndex];
            if (!currentVariant) return "Generic";

            const variantName = currentVariant.nazev.toLowerCase();
            if (/premium/.test(variantName)) return "Premium";
            if (/optimum/.test(variantName)) return "Optimum";

            const joined = this.tableHeaders.join(" ").toLowerCase();
            if (/windomy|sql|oksoft/.test(joined)) return "OkSoft";
            if (/starlit|optimum|premium/.test(joined)) return "Starlit";
            return "Generic";
        },

        getUnitLabel() {
            const type = this.detectCenikType();
            if (type === "Premium") return "uživatelů";
            if (type === "Optimum") return "zařízení";
            return "jednotek";
        },

        getCalculationType() {
            const type = this.detectCenikType();
            if (type === "Premium") {
                return {
                    unitType: "users",
                    hasActivationFee: true,
                    hasOneTimeLicense: false,
                    modulesIncluded: false,
                    pricingStructure: "monthly_only",
                };
            }
            if (type === "Optimum") {
                return {
                    unitType: "devices",
                    hasActivationFee: false,
                    hasOneTimeLicense: true,
                    modulesIncluded: false,
                    pricingStructure: "onetime_plus_monthly",
                };
            }
            return {
                unitType: "units",
                hasActivationFee: false,
                hasOneTimeLicense: true,
                modulesIncluded: false,
                pricingStructure: "onetime_plus_monthly",
            };
        },

        /* ===== Slider podle tabulky ===== */
        setupAllowedUnits(map) {
            this.allowedUnits = this.priceTable
                .map((r) => parseInt(r[map.units], 10))
                .filter((v) => Number.isFinite(v))
                .sort((a, b) => a - b)
                .filter((v, i, arr) => i === 0 || v !== arr[i - 1]);

            if (!this.allowedUnits.length) return;

            const def = 500;
            const found = this.allowedUnits.findIndex((v) => v >= def);
            this.currentIndex = found !== -1 ? found : this.allowedUnits.length - 1;
            this.currentUnits = this.allowedUnits[this.currentIndex];

            this.$root
                .find(".range-slider-input")
                .attr({ min: 0, max: this.allowedUnits.length - 1, step: 1 })
                .val(this.currentIndex);
            this.$root.find(".range-value-input").val(this.currentUnits);

            this.$root.find(".number-label label:first").text(this.allowedUnits[0].toLocaleString("cs-CZ"));
            this.$root.find(".number-label label:last").text(this.allowedUnits[this.allowedUnits.length - 1].toLocaleString("cs-CZ"));

            this.updateSliderFill();
        },

        /* ===== Řádek dle bytů ===== */
        getRow(units, map) {
            for (let i = 0; i < this.priceTable.length; i++) {
                const row = this.priceTable[i];
                const limit = parseInt(row[map.units], 10);
                if (Number.isFinite(limit) && units <= limit) return row;
            }
            return this.priceTable[this.priceTable.length - 1] || null;
        },

        /* ===== Další zařízení ===== */
        deriveNextPrice(row, firstIdx, nextIdx) {
            const first = row[firstIdx];
            const next = row[nextIdx];
            const firstClean = this.cleanNum(first);
            const nextClean = this.cleanNum(next);
            if (firstClean === "individual" || nextClean === "individual") {
                return "individual";
            }

            const pct = this.findPercent(next) ?? this.findPercent(first);
            if (pct !== null) {
                const base = firstClean;
                if (!this.isFinitePrice(base)) {
                    return this.isFinitePrice(nextClean) ? nextClean : 0;
                }
                return Math.round((base * pct) / 100);
            }
            const num = nextClean;
            return Number.isFinite(num) ? num : 0;
        },

        /* ===== Ceny modulů (na základě shody názvu s hlavičkou tabulky) ===== */
        updateModulePricesFromRow(row, map) {
            this.$root.find(`[data-variant-index="${this.currentVariantIndex}"] .module-checkbox`).each((_, el) => {
                const $cb = $(el);
                const $item = $cb.closest(".item");
                const moduleName = ($item.find(".text-item").text() || "").trim();
                const $priceEl = $item.find(".module-price");

                let price = null;
                let rawValue = null;

                // Najdi sloupec podle shody názvu modulu s hlavičkou tabulky
                for (let colIndex = 0; colIndex < this.tableHeaders.length; colIndex++) {
                    const headerName = this.tableHeaders[colIndex].trim();

                    // Porovnej názvy (ignoruj velikost písmen a diakritiku)
                    const normalizeText = (text) =>
                        text.toLowerCase().replace(/[áčďéěíňóřšťůúýž]/g, (match) => {
                            const map = { á: "a", č: "c", ď: "d", é: "e", ě: "e", í: "i", ň: "n", ó: "o", ř: "r", š: "s", ť: "t", ů: "u", ú: "u", ý: "y", ž: "z" };
                            return map[match] || match;
                        });

                    const normalizedModuleName = normalizeText(moduleName);

                    // Rozděl hlavičku sloupce podle čárek (pro případy jako "Zvýšení výkonu,Instalace modulu")
                    const headerParts = headerName.split(",").map((part) => part.trim());

                    // Testuj shodu s každou částí hlavičky
                    for (const headerPart of headerParts) {
                        const normalizedHeaderName = normalizeText(headerPart);
                        let isMatch = false;

                        // 1) Přesná shoda
                        if (normalizedModuleName === normalizedHeaderName) {
                            isMatch = true;
                        }
                        // 2) Název modulu obsahuje název sloupce
                        else if (normalizedModuleName.includes(normalizedHeaderName)) {
                            isMatch = true;
                        }
                        // 3) Název sloupce obsahuje název modulu
                        else if (normalizedHeaderName.includes(normalizedModuleName)) {
                            isMatch = true;
                        }
                        // 4) Hledání klíčových slov ze sloupce v názvu modulu
                        else {
                            const headerWords = normalizedHeaderName.split(/\s+/).filter((word) => word.length > 2); // Slova delší než 2 znaky
                            const foundWords = headerWords.filter((word) => normalizedModuleName.includes(word));

                            // Pokud většina slov ze sloupce je v názvu modulu, považuj za shodu
                            if (headerWords.length > 0 && foundWords.length >= Math.ceil(headerWords.length * 0.6)) {
                                isMatch = true;
                                console.log(`Nalezena shoda podle klíčových slov: "${headerWords.join(" ")}" -> "${foundWords.join(" ")}" v modulu "${moduleName}"`);
                            }
                        }

                        if (isMatch) {
                            rawValue = row[colIndex];
                            price = this.cleanNum(rawValue);
                            // Detekce měsíční vs jednorázové podle hlavičky sloupce
                            const headerLower = normalizedHeaderName;
                            const hasMonthly = /(měsíční|mesicni|měsíčně|mesicne|monthly|rozšíření|extension|rozsireni)/i.test(headerLower);
                            const hasOnetime = /(jednorázově|jednorazove|jednorazově|onetime)/i.test(headerLower);
                            const isMonthlyColumn = hasMonthly ? true : hasOnetime ? false : null; // null = neurčeno
                            $cb.data("is-monthly", isMonthlyColumn === true);
                            $cb.data("is-onetime", isMonthlyColumn === false);
                            console.log(`Nalezena shoda: modul "${moduleName}" -> sloupec "${headerName}" (index ${colIndex}) -> cena ${price}, měsíční: ${isMonthlyColumn}`);
                            break;
                        }
                    }

                    if (price !== null) break; // Pokud jsme našli cenu, ukonči hledání
                }

                // Fallback na ACF cenu (ne pro „individuálně“ z tabulky)
                if (price === null || (price !== "individual" && Number.isFinite(price) && price <= 0)) {
                    price = parseInt($cb.data("base-price")) || 0;
                    $cb.data("is-monthly", undefined);
                    $cb.data("is-onetime", undefined);
                    console.log(`Používám ACF fallback cenu pro modul "${moduleName}": ${price}`);
                }

                // Format price display
                $priceEl.text(this.formatPrice(price));
                $cb.data("current-price", price);
            });
        },

        /* ===== Přepočet ===== */
        calculate() {
            const map = this.detectColumns();
            const row = this.getRow(this.currentUnits, map);
            if (!row) return;

            const calcType = this.getCalculationType();

            // 1) přecenit moduly pro aktuální řádek
            this.updateModulePricesFromRow(row, map);

            // 2) základní ceny
            const first = this.cleanNum(row[map.first]);
            const next = this.deriveNextPrice(row, map.first, map.next);
            const monthly = this.cleanNum(row[map.monthly]);

            // 3) součet modulů - odděleně měsíční a jednorázové podle sloupce v tabulce
            let modulesOneTime = 0;
            let modulesMonthly = 0;
            let moduleIndividualOneTime = false;
            let moduleIndividualMonthly = false;
            if (!calcType.modulesIncluded) {
                const $priceSection = this.$root.find(".price");
                const hasOnetimeLicense = $priceSection.length > 0 && $priceSection.is(":visible");

                this.$root.find(`[data-variant-index="${this.currentVariantIndex}"] .module-checkbox`).each(function () {
                    if ($(this).prop("checked")) {
                        const v = $(this).data("current-price");
                        if (v === "individual") {
                            const isMonthly = $(this).data("is-monthly");
                            const isOnetime = $(this).data("is-onetime");
                            if (isMonthly === true) {
                                moduleIndividualMonthly = true;
                            } else if (isOnetime === true || isMonthly === false) {
                                moduleIndividualOneTime = true;
                            } else if (hasOnetimeLicense) {
                                moduleIndividualOneTime = true;
                            } else {
                                moduleIndividualMonthly = true;
                            }
                            return;
                        }
                        if (v !== "included" && Number.isFinite(Number(v))) {
                            const price = Number(v);
                            const isMonthly = $(this).data("is-monthly");
                            const isOnetime = $(this).data("is-onetime");

                            // Přiřazení podle sloupce v tabulce (měsíčně vs jednorázově)
                            if (isMonthly === true) {
                                modulesMonthly += price;
                            } else if (isOnetime === true || isMonthly === false) {
                                modulesOneTime += price;
                            } else {
                                // Fallback: neurčeno z hlavičky - použij logiku podle existence licence
                                if (hasOnetimeLicense) {
                                    modulesOneTime += price;
                                } else {
                                    modulesMonthly += price;
                                }
                            }
                        }
                    }
                });
            }

            // 4) kalkulace podle typu
            let oneTime = 0;
            let monthlyTotal = monthly;

            if (calcType.pricingStructure === "onetime_plus_monthly") {
                // OPTIMUM: jednorázově za licenci + zařízení
                if (this.isFinitePrice(first) && this.isFinitePrice(next)) {
                    const licenceOneTime = first + Math.max(0, this.currentDevices - 1) * next;
                    oneTime = licenceOneTime + modulesOneTime;
                } else {
                    oneTime = "individual";
                }
                if (moduleIndividualOneTime) {
                    oneTime = "individual";
                }

                if (this.isFinitePrice(monthly)) {
                    monthlyTotal = monthly + modulesMonthly;
                } else {
                    monthlyTotal = "individual";
                }
                if (moduleIndividualMonthly) {
                    monthlyTotal = "individual";
                }
            } else if (calcType.pricingStructure === "monthly_only") {
                // PREMIUM: pouze měsíční + aktivační poplatek
                const baseActivation = calcType.hasActivationFee ? 2000 : 0;
                if (moduleIndividualOneTime) {
                    oneTime = "individual";
                } else {
                    oneTime = baseActivation + modulesOneTime;
                }

                const additionalUsers = Math.max(0, this.currentDevices - 2);
                if (this.isFinitePrice(monthly) && this.isFinitePrice(next)) {
                    const additionalUsersCost = additionalUsers * next;
                    monthlyTotal = monthly + additionalUsersCost + modulesMonthly;
                } else {
                    monthlyTotal = "individual";
                }
                if (moduleIndividualMonthly) {
                    monthlyTotal = "individual";
                }
            }

            // 5) render
            this.renderPricing(calcType, first, next, oneTime, monthlyTotal);
        },

        renderPricing(calcType, first, next, oneTime, monthly) {
            const unitLabel = this.getUnitLabel();

            if (calcType.pricingStructure === "onetime_plus_monthly") {
                // OPTIMUM rendering
                const $deviceFirst = this.$root.find(".device-price-first");
                const $deviceNext = this.$root.find(".device-price-next");
                const $priceOnetime = this.$root.find(".price-onetime");
                const $priceMonthly = this.$root.find(".price-monthly");

                if ($deviceFirst.length) $deviceFirst.text(this.formatPrice(first));
                if ($deviceNext.length) $deviceNext.text(this.formatPrice(next));
                if ($priceOnetime.length) $priceOnetime.text(this.formatPrice(oneTime));
                if ($priceMonthly.length) {
                    $priceMonthly.text(monthly === "individual" ? "Individuálně" : "+ " + this.formatPrice(monthly) + " měsíčně");
                }
            } else if (calcType.pricingStructure === "monthly_only") {
                // PREMIUM rendering
                const $deviceFirst = this.$root.find(".device-price-first");
                const $deviceNext = this.$root.find(".device-price-next");
                const $priceOnetime = this.$root.find(".price-onetime");
                const $priceMonthly = this.$root.find(".price-monthly");

                if ($deviceFirst.length) $deviceFirst.text("V ceně");
                if ($deviceNext.length) $deviceNext.text(this.formatPrice(next) + " měsíčně");
                if ($priceOnetime.length) $priceOnetime.text(this.formatPrice(oneTime));
                if ($priceMonthly.length) $priceMonthly.text(this.formatPrice(monthly) + " měsíčně");
            }

            // Common totals - pouze pokud elementy existují
            const $totalUnits = this.$root.find(".total-units");
            const $totalOnetime = this.$root.find(".total-onetime");
            const $totalMonthly = this.$root.find(".total-monthly");

            if ($totalUnits.length) $totalUnits.text(this.currentUnits.toLocaleString("cs-CZ"));
            if ($totalOnetime.length) $totalOnetime.text(this.formatPrice(oneTime));
            if ($totalMonthly.length) $totalMonthly.text(this.formatPrice(monthly));

            // Update section titles and device count label
            this.$root.find(".number-units__title h3").text(`Počet ${unitLabel}:`);

            // Section titles are set from ACF in PHP - don't override them
        },

        /* ===== Eventy ===== */
        bindEvents() {
            const self = this;

            // slider (index) - pouze pro viditelný variant
            this.$root.on("input", ".range-slider-input", function () {
                const $this = $(this);
                const $container = $this.closest(".variant-content-right");

                // Pracuj pouze s viditelným variantem
                if ($container.is(":visible")) {
                    const idx = Math.min(Math.max(parseInt($this.val(), 10) || 0, 0), self.allowedUnits.length - 1);
                    self.currentIndex = idx;
                    self.currentUnits = self.allowedUnits[idx];
                    $container.find(".range-value-input").val(self.currentUnits);
                    self.calculate();
                    self.updateSliderFill();
                }
            });

            // ruční zadání -> nejbližší hodnota - pouze pro viditelný variant
            this.$root.on("change", ".range-value-input", function () {
                const $this = $(this);
                const $container = $this.closest(".variant-content-right");

                // Pracuj pouze s viditelným variantem
                if ($container.is(":visible")) {
                    const raw = parseInt($this.val(), 10);
                    const idx = self.findNearestIndex(raw);
                    self.currentIndex = idx;
                    self.currentUnits = self.allowedUnits[idx];
                    $container.find(".range-value-input").val(self.currentUnits);
                    $container.find(".range-slider-input").val(idx);
                    self.calculate();
                    self.updateSliderFill();
                }
            });

            // +/- tlačítka - pracuj pouze s viditelným variantem
            this.$root.on("click", ".range-minus", function () {
                const $container = $(this).closest(".variant-content-right");
                if ($container.is(":visible") && self.currentIndex > 0) {
                    self.currentIndex--;
                    self.updateUnitsDisplay();
                }
            });
            this.$root.on("click", ".range-plus", function () {
                const $container = $(this).closest(".variant-content-right");
                if ($container.is(":visible") && self.currentIndex < self.allowedUnits.length - 1) {
                    self.currentIndex++;
                    self.updateUnitsDisplay();
                }
            });

            // počet zařízení/uživatelů - nejprve odstraň staré event handlery
            this.$root.off("click", ".button-count .minus").off("click", ".button-count .plus");
            this.$root.on("click", ".button-count .minus", function () {
                const calcType = self.getCalculationType();
                const minValue = calcType.pricingStructure === "monthly_only" ? 1 : 1; // Pro Premium min 1 uživatel, pro Optimum min 1 zařízení

                if (self.currentDevices > minValue) {
                    self.currentDevices--;
                    self.$root.find(".button-count p").text(self.currentDevices);
                    self.calculate();
                }
            });
            this.$root.on("click", ".button-count .plus", function () {
                if (self.currentDevices < 99) {
                    self.currentDevices++;
                    self.$root.find(".button-count p").text(self.currentDevices);
                    self.calculate();
                }
            });

            // checkboxy modulů – okamžitý přepočet (i s iCheck eventy)
            const checkboxEvents = "change input click ifChanged ifChecked ifUnchecked";
            this.$root.on(checkboxEvents, ".variant-content:visible .module-checkbox", function () {
                self.calculate();
            });

            // odkazy v textu – zastavit další handlery, aby se nespustilo přepnutí checkboxu (odkaz musí otevřít)
            this.$root.on("click", ".variant-content:visible .col-left__standard-modul .item a", function (e) {
                e.stopImmediatePropagation();
            });

            // klik na řádku modulu (mimo input/label/ikony/cenu/odkazy) – přepne checkbox
            this.$root.on("click", ".variant-content:visible .col-left__standard-modul .item", function (e) {
                const t = e.target;
                const el = t && t.nodeType === 1 ? t : t && t.parentElement;
                const isLink = el && (el.tagName === "A" || (el.closest && el.closest("a")));
                if ($(t).is("input, label, .module-price, svg, path, a") || isLink) return;
                const $cb = $(this).find(".module-checkbox");
                $cb.prop("checked", !$cb.prop("checked")).trigger("change");
            });

            // toggle buttons for variants
            this.$root.on("click", ".cenik__toggle-btn", function (e) {
                e.preventDefault();
                const variantIndex = parseInt($(this).data("variant-index"));
                self.switchVariant(variantIndex);
            });
        },

        findNearestIndex(value) {
            if (!Number.isFinite(value)) return this.currentIndex;
            let bestIdx = 0;
            let bestDiff = Infinity;
            this.allowedUnits.forEach((v, i) => {
                const d = Math.abs(v - value);
                if (d < bestDiff) {
                    bestDiff = d;
                    bestIdx = i;
                }
            });
            return bestIdx;
        },

        updateUnitsDisplay() {
            this.currentUnits = this.allowedUnits[this.currentIndex];
            this.$root.find(".variant-content-right:visible .range-slider-input").val(this.currentIndex);
            this.$root.find(".variant-content-right:visible .range-value-input").val(this.currentUnits);
            this.calculate();
            this.updateSliderFill();
        },

        /* ===== Switch variant ===== */
        switchVariant(variantIndex) {
            if (!this.cenikVariants[variantIndex]) return;

            this.currentVariantIndex = variantIndex;
            const variant = this.cenikVariants[variantIndex];

            // Update data
            this.priceTable = variant.price_data;
            this.tableHeaders = variant.table_headers;

            // Re-detect cenikType for new variant
            this.cenikType = this.detectCenikType();

            // Update UI
            this.updateVariantContent(variant);

            // Recalculate with new data
            const map = this.detectColumns();
            this.setupAllowedUnits(map);

            // Reset range slider for current variant
            this.resetRangeSliderForVariant();

            this.calculate();

            // Update toggle buttons
            this.$root.find(".cenik__toggle-btn").removeClass("active");
            this.$root.find(`.cenik__toggle-btn[data-variant-index="${variantIndex}"]`).addClass("active");

            // Update title
            this.$root.find(".cenik__title").text(variant.nazev || "Ceník");
        },

        updateVariantContent(variant) {
            // Hide all variant content containers (left column)
            this.$root.find(".variant-content").hide();

            // Hide all right column variant content
            this.$root.find(".variant-content-right").hide();

            // Show the selected variant content (left column)
            this.$root.find(`.variant-content[data-variant-index="${variant.index}"]`).show();

            // Show the selected right column content
            this.$root.find(`.variant-content-right[data-variant-index="${variant.index}"]`).show();

            // Re-initialize iCheck for visible checkboxes only
            if ($.fn.iCheck) {
                // Destroy existing iCheck instances
                this.$root.find(".module-checkbox").iCheck("destroy");

                // Re-initialize only for visible variant
                this.$root.find(`[data-variant-index="${variant.index}"] .module-checkbox`).iCheck({
                    checkboxClass: "icheckbox",
                    radioClass: "iradio",
                });
            }
        },

        resetRangeSliderForVariant() {
            // Get the current variant container
            const $variantContainer = this.$root.find(`.variant-content-right[data-variant-index="${this.currentVariantIndex}"]`);
            if (!$variantContainer.length) return;

            // Reset slider to initial state for current variant
            const $rangeSlider = $variantContainer.find(".range-slider-input");
            const $rangeInput = $variantContainer.find(".range-value-input");

            if ($rangeSlider.length && this.allowedUnits.length > 0) {
                // Set proper min/max values based on current variant's allowed units
                $rangeSlider.attr({
                    min: 0,
                    max: this.allowedUnits.length - 1,
                    step: 1,
                });

                // Reset to current index and units
                $rangeSlider.val(this.currentIndex);
                $rangeInput.val(this.currentUnits);

                // Update labels for min/max values
                $variantContainer.find(".number-label label:first").text(this.allowedUnits[0].toLocaleString("cs-CZ"));
                $variantContainer.find(".number-label label:last").text(this.allowedUnits[this.allowedUnits.length - 1].toLocaleString("cs-CZ"));

                // Update slider visual fill
                this.updateSliderFill();
            }
        },

        updateRightColumnTexts(variantIndex) {
            // Texty pravého sloupce se načtou z PHP a jsou statické
            // Tata metoda je připravena pro případnou dynamickou aktualizaci v budoucnu
        },

        /* ===== Init ===== */
        init() {
            this.$root = $(".cenik").first();
            if (!this.$root.length) return;

            // Load variants data
            this.cenikVariants = JSON.parse(this.$root.attr("data-cenik-variants") || "[]");

            if (!this.cenikVariants.length) return;

            // Set initial variant (first one)
            const initialVariant = this.cenikVariants[0];
            this.priceTable = initialVariant.price_data;
            this.tableHeaders = initialVariant.table_headers;

            // volitelně: override z data-columns
            const colsAttr = this.$root.attr("data-columns");
            this.columnsOverride = colsAttr ? JSON.parse(colsAttr) : null;

            this.cenikType = this.detectCenikType();

            const map = this.detectColumns();
            this.setupAllowedUnits(map);
            this.bindEvents();
            this.calculate();
        },
    };

    // exporty (zpětná kompatibilita)
    window.CenikCalculator = CenikCalculator;

    // shim pro starší kód `new PricingCalculator().init()`
    class PricingCalculatorShim {
        constructor(opts) {
            this.opts = opts || {};
        }
        init() {
            CenikCalculator.init();
        }
        calculate() {
            CenikCalculator.calculate();
        }
        updateUnitsDisplay() {
            CenikCalculator.updateUnitsDisplay();
        }
    }
    window.PricingCalculator = PricingCalculatorShim;

    // $(document).ready(() => CenikCalculator.init()); // ODSTRANĚNO - duplikát inicializace
})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
    const rangeInputs = document.querySelectorAll('input[type="range"]');

    rangeInputs.forEach((input) => {
        updateRangeProgress(input);

        input.addEventListener("input", function () {
            updateRangeProgress(this);
        });
    });

    // Inicializuj kalkulačku cen
    if (document.querySelector(".cenik")) {
        window.priceCalculator = new PricingCalculator();
        window.priceCalculator.init();
    }
});
